var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('display',{attrs:{"display":"table","model_name":"payment_method","show_btn_edit":false,"properties":_vm.properties,"models":_vm.models}})}
var staticRenderFns = []

export { render, staticRenderFns }